/**
 * Engine API
 * Engine API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface TagDTO {
    id?: number;
    name: string;
    description?: string;
    enable?: boolean;
    partners?: Array<string>;
    createAt?: Date;
    lastUpdated?: Date;
    version?: number;
    count?: number;
}
